import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {IValidationErrorObject} from '../../../../incase-domain/common/validationErrorResponse';
import {IElementVideo} from '../../../../incase-domain/elements/video';
import {setSelectedElementId} from '../../../../store/actions/slide';
import {generateErrorMessages, getErrorClasses} from '../../../../utils/validation';
import {TABS} from '../../form/part/tabs';
import AnimationForm from '../common/animationForm';
import Button from '../../../../incase-domain/components/button/Button';
import ElementShadow from '../common/elementShadow';
import {useHighlightedElement, useSetHighlightedElement} from '../../../../utils/hooks/slideUpdates/useSetSlideElement';

interface HighlightedVideoElementComponentProps {
    errors: IValidationErrorObject | null;
    activeTab: string;
}

function HighlightedVideoElementComponent(props: HighlightedVideoElementComponentProps): ReactElement {
    const {errors, activeTab} = props;
    const updateHighlightedElement = useSetHighlightedElement();
    const highlightedElement = useHighlightedElement() as IElementVideo;
    const {t} = useTranslation();
    const dispatch = useDispatch();

    if (activeTab === TABS.STYLE.id) {
        return <ElementShadow highlightedElement={highlightedElement} highlightedElementChangeHandler={updateHighlightedElement} />;
    }

    if (activeTab === TABS.ADVANCED.id) {
        return (
            <>
                <AnimationForm
                    appearAfter={highlightedElement.appearAfter || 0}
                    elementAnimations={highlightedElement.elementAnimations}
                    highlightedElementChangeHandler={updateHighlightedElement}
                />
            </>
        );
    }

    return (
        <>
            <div className="l-group--form">
                <div className={`l-group__item ${getErrorClasses(errors, 'videoSource')}`}>
                    <div className="u-flex u-h-center">
                        <Button
                            variant="soft"
                            color="secondary"
                            size="sm"
                            fullWidth
                            onClick={() => {
                                dispatch(setSelectedElementId(highlightedElement.id));
                            }}
                        >
                            {highlightedElement.videoSource?.src || highlightedElement.videoSrc
                                ? t('designSidepanel.replaceVideo')
                                : t('designSidepanel.selectVideo')}
                        </Button>
                    </div>

                    {generateErrorMessages(errors, 'videoSource.src')}
                </div>
            </div>
        </>
    );
}

export default HighlightedVideoElementComponent;
